import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime, fromNow } from "@/lib/constants";
import { Skeleton } from "@/components/ui/skeleton";
import { Bell, Mail, Radio, AlertTriangle } from "lucide-react";

const ICONS = {
  email: { icon: Mail, color: "#899277" },
  push: { icon: Radio, color: "#d15d36" },
  ops_alert: { icon: AlertTriangle, color: "#b33a3a" },
};

export default function NotificationsPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="mx-auto max-w-3xl">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-stark-terracotta text-white"><Bell className="h-6 w-6" /></div>
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-stark-ink sm:text-3xl">Alerts</h1>
          <p className="text-sm text-stark-muted">Delay, arrival & delivery notifications.</p>
        </div>
      </div>

      <div className="mt-6 space-y-3">
        {!items ? (
          [...Array(5)].map((_, i) => <Skeleton key={i} className="h-20 rounded-2xl" />)
        ) : items.length === 0 ? (
          <div className="stark-card flex flex-col items-center justify-center py-20 text-center">
            <Bell className="h-10 w-10 text-stark-border-strong" />
            <p className="mt-3 font-semibold text-stark-ink">No alerts yet</p>
            <p className="text-sm text-stark-muted">Notifications appear here as jobs progress.</p>
          </div>
        ) : (
          items.map((n, i) => {
            const cfg = ICONS[n.kind] || ICONS.email;
            const Icon = cfg.icon;
            return (
              <div key={n.id || i} className="stark-card stark-fade-up flex items-start gap-4 p-4" style={{ animationDelay: `${i * 40}ms` }} data-testid={`notification-${i}`}>
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl" style={{ backgroundColor: `${cfg.color}1a`, color: cfg.color }}>
                  <Icon className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-3">
                    <div className="font-bold text-stark-ink">{n.subject}</div>
                    <div className="shrink-0 text-xs text-stark-muted">{fromNow(n.created_at)}</div>
                  </div>
                  <p className="mt-0.5 line-clamp-2 text-sm text-stark-muted">{n.body}</p>
                  <div className="mt-1 text-[11px] font-medium text-stark-muted">To: {n.to}</div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
